import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Legal.css';

function Datenschutz() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <button className="legal-back" onClick={() => navigate('/')}>
        ← Zurück
      </button>
      <div className="legal-content">
        <h1>Datenschutzerklärung</h1>
        <p className="legal-updated">Stand: Mai 2026</p>

        <h2>1. Verantwortlicher</h2>
        <p>
          Emin Tavli<br />
          Westendstraße 28<br />
          90427 Nürnberg<br />
          E-Mail: <a href="mailto:tavlin@hotmail.de">tavlin@hotmail.de</a>
        </p>

        <h2>2. Hosting</h2>
        <p>
          Diese Website wird gehostet von <strong>Vercel Inc.</strong>, 340 Pine Street, Suite 701,
          San Francisco, CA 94104, USA. Beim Aufruf der Website werden durch den Hosting-Anbieter
          automatisch Server-Log-Daten erfasst (IP-Adresse, Browsertyp, aufgerufene Seite,
          Datum und Uhrzeit des Zugriffs). Diese Daten werden zur Sicherstellung des Betriebs
          benötigt und nach spätestens 30 Tagen gelöscht. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO
          (berechtigtes Interesse am sicheren Betrieb).
        </p>
        <p>
          Vercel kann Daten in die USA übertragen. Vercel ist nach dem EU-U.S. Data Privacy Framework
          zertifiziert. Weitere Informationen:{' '}
          <a href="https://vercel.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">
            vercel.com/legal/privacy-policy
          </a>.
        </p>

        <h2>3. Lokale Browserspeicherung (localStorage)</h2>
        <p>
          Diese Website speichert zwei rein technische Einstellungen lokal in Ihrem Browser
          (localStorage):
        </p>
        <ul>
          <li><strong>theme</strong>: Ihre Farbschema-Präferenz (hell oder dunkel)</li>
          <li><strong>language</strong>: Ihre Sprachpräferenz (de / en / tr)</li>
        </ul>
        <p>
          Diese Daten verlassen Ihren Browser nie, werden nicht an Server übertragen und dienen
          ausschließlich der Darstellung der Website. Es werden keine Tracking-Cookies oder
          sonstige Cookies gesetzt. Eine Einwilligung ist nach § 25 Abs. 2 TTDSG nicht erforderlich,
          da die Speicherung technisch notwendig ist.
        </p>

        <h2>4. Kontaktaufnahme per E-Mail</h2>
        <p>
          Wenn Sie mich per E-Mail kontaktieren, werden Ihre Angaben (E-Mail-Adresse, Nachrichteninhalt)
          zur Bearbeitung Ihrer Anfrage gespeichert. Diese Daten werden nicht an Dritte weitergegeben
          und nach Abschluss des Anliegens gelöscht. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.
        </p>

        <h2>5. Externe Links</h2>
        <p>
          Diese Website enthält Links zu externen Diensten (LinkedIn, GitHub). Beim Klick auf
          diese Links gelten die Datenschutzbestimmungen des jeweiligen Anbieters. Ich habe keinen
          Einfluss auf deren Datenverarbeitung.
        </p>

        <h2>6. Keine Analyse-Tools</h2>
        <p>
          Es werden keine Analyse-, Tracking- oder Werbedienste eingesetzt (kein Google Analytics,
          kein Facebook Pixel o. ä.).
        </p>

        <h2>7. Ihre Rechte</h2>
        <p>
          Sie haben nach der DSGVO folgende Rechte:
        </p>
        <ul>
          <li>Auskunft über Ihre gespeicherten Daten (Art. 15)</li>
          <li>Berichtigung unrichtiger Daten (Art. 16)</li>
          <li>Löschung Ihrer Daten (Art. 17)</li>
          <li>Einschränkung der Verarbeitung (Art. 18)</li>
          <li>Widerspruch gegen die Verarbeitung (Art. 21)</li>
          <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77),
            zuständig ist das Bayerische Landesamt für Datenschutzaufsicht (BayLDA),{' '}
            <a href="https://www.lda.bayern.de" target="_blank" rel="noopener noreferrer">lda.bayern.de</a>
          </li>
        </ul>
        <p>
          Zur Ausübung Ihrer Rechte wenden Sie sich an:{' '}
          <a href="mailto:tavlin@hotmail.de">tavlin@hotmail.de</a>
        </p>
      </div>
    </div>
  );
}

export default Datenschutz;
